import React, { useCallback } from 'react'
import { Box, Container } from '@mui/material'

const Body = ({children}) => {
  
  const [ totalHeight, setTotalHeight ] = React.useState(0)
  
  const header = document.getElementsByTagName('header')
  const footer = document.getElementsByClassName('footer-loader')

  const updateSize = useCallback( () => {

    const heightHeader = header.length ? header[0].offsetHeight : 0
    const footerHeight = footer.length ? footer[0].offsetHeight : 0
    
    const total = heightHeader + footerHeight

    //console.log('heightHeader', heightHeader, ' -- ', 'footerHeight', footerHeight, ' -- total ->', total, ' -- HEADER -->', header, )
    
    setTotalHeight(total)

  },[header, footer])

  React.useEffect( ( ) => {
    document.addEventListener('DOMContentLoaded', updateSize)
    updateSize()
    return () => document.removeEventListener('DOMContentLoaded', updateSize)
    
  }, [updateSize])

  React.useLayoutEffect( () => { 
    
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
    
  }, [updateSize])

  

  
  return <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: !totalHeight ? `100vh` : `calc(100vh - ${totalHeight}px)`,
      position: !totalHeight ? 'fixed' : ''
    }}
       
      component={Container}
      
    >
      < >
        {children}
      </>
    </Box>
}

export default Body